import { Box, Grid, Typography, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import parse from 'html-react-parser';
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconTelegram from '../../../components/Icons/IconTelegram';
import StyledTelegram from './styles';

const Telegram = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const label1 = t('telegram-content');
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

    return (
        <StyledTelegram>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    // minHeight: '100vh',
                    backgroundColor: '#F0EEEF',
                    color: theme.palette.background.secondary,
                    paddingLeft: 45,
                    paddingRight: 45,
                    paddingTop: 8,
                    paddingBottom: 10,
                    [theme.breakpoints.down('md')]: {
                        px: 1,
                        py: 1,
                    },
                }}
            >
                <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 5, lg: 5 }}>
                    {/* Left Content */}
                    <Grid item xs={12} md={12} lg={12}>
                        <Box
                            justifyContent={'center'}
                            sx={{
                                padding: '40px 15px 10px 15px',
                            }}
                        >
                            <Typography
                                variant="body1"
                                sx={{
                                    mt: 1,
                                    mb: 2,
                                    lineHeight: '44px',
                                    wordWrap: 'break-word',
                                    fontWeight: 700,
                                    fontSize: '47.81px',
                                    color: '#000000',
                                    lineHeight: '48px',
                                    textAlign: 'center',
                                    [theme.breakpoints.down('md')]: {
                                        fontSize: '40px',
                                        lineHeight: '47.73px',
                                        textAlign: 'center',
                                        display: 'none',
                                    },
                                }}
                            >
                                {/* <motion.div
                                    initial={{
                                        opacity: 0,
                                        y: 100,
                                    }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0, // Slide in to its original position
                                        transition: {
                                            duration: 1, // Animation duration
                                        },
                                    }}
                                // viewport={{ once: true }}
                                > */}
                                {t('telegram-title')}
                                {/* </motion.div> */}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    mt: 1,
                                    mb: 2,
                                    lineHeight: '44px',
                                    wordWrap: 'break-word',
                                    fontWeight: 700,
                                    fontSize: '47.81px',
                                    color: '#000000',
                                    lineHeight: '48px',
                                    display: 'none',
                                    [theme.breakpoints.down('md')]: {
                                        fontSize: '40px',
                                        lineHeight: '47.73px',
                                        textAlign: 'center',
                                        display: 'flex',
                                        justifyContent: 'center',
                                    },
                                }}
                            >
                                {t('telegram-title')}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    // lineHeight: 1.8,
                                    // wordWrap: 'break-word',
                                    fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                                    fontSize: '17.462px',
                                    color: '#6C6964',
                                    lineHeight: '25.6px',
                                    mb: 2.5,
                                    textAlign: 'center',
                                    [theme.breakpoints.down('md')]: {
                                        fontSize: '18px',
                                        lineHeight: '23.4px',
                                        textAlign: 'center',
                                        display: 'none',
                                    },
                                }}
                            >
                                {/* <motion.div
                                    initial={{
                                        opacity: 0,
                                        y: 100,
                                    }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0, // Slide in to its original position
                                        transition: {
                                            duration: 1, // Animation duration
                                            delay: 0.8,
                                        },
                                    }}
                                // viewport={{ once: true }}
                                > */}
                                {parse(label1)}
                                {/* </motion.div> */}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    lineHeight: 1.8,
                                    // wordWrap: 'break-word',
                                    fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                                    fontSize: '17.462px',
                                    color: '#6C6964',
                                    lineHeight: '25.6px',
                                    display: 'none',
                                    mb: 2.5,
                                    [theme.breakpoints.down('md')]: {
                                        fontSize: '18px',
                                        lineHeight: '23.4px',
                                        textAlign: 'center',
                                        display: 'block',
                                        justifyContent: 'center',
                                    },
                                }}
                            >
                                {parse(label1)}
                            </Typography>
                            {isMobile ? (
                                <Box textAlign={'center'} display={'flex'} justifyContent={'center'}>
                                    <IconTelegram />
                                </Box>
                            ) : (
                                <Box textAlign={'center'} display={'flex'} justifyContent={'center'}>
                                    {/* <motion.div
                                        initial={{
                                            opacity: 0,
                                            y: 100,
                                        }}
                                        whileInView={{
                                            opacity: 1,
                                            y: 0, // Slide in to its original position
                                            transition: {
                                                duration: 1, // Animation duration
                                                delay: 1.3,
                                            },
                                        }}
                                    // viewport={{ once: true }}
                                    > */}
                                    <IconTelegram />
                                    {/* </motion.div> */}
                                </Box>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </StyledTelegram>
    );
};

export default Telegram;
